import { createSelector } from '@reduxjs/toolkit';

import { ApplicationState } from '@t/store';

const selectState = (state: ApplicationState) => state.whiteMail;

export const selectFilteredValues = createSelector(selectState, ({ filter }) => filter);
